//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowCTABlockCenter",
    props: {
        ...defaultBlockProps,
    },
    data: () => ({}),
};
